import React, { Component } from "react";
import { alert, loading, t } from "../../../components/CustomComponent.js";
import { requestOtp, verifyOtp } from "../../../services/partner.service.js";
import ICON from "../icons.js";
import PartnerField from "./PartnerField.js";
import {
  DOC_ACCEPT,
  DOC_SLOTS,
  DOC_TYPES,
  OTP_EXPIRE_SEC,
  OTP_LENGTH,
  OTP_MAX_ATTEMPT,
  OTP_RESEND_SEC,
  countdown,
  docFileError,
  fileSize,
  maskEmail,
} from "../partner_option.js";

/* ============================================================================
 * PartnerVerify — ขั้นที่ 2 : ยืนยันตัวตน
 *
 * สองเรื่องในขั้นเดียว เพราะเป็นการพิสูจน์ว่า "คนที่กรอกมามีตัวตนจริง" ทั้งคู่
 *   1. ยืนยันอีเมลด้วยรหัส OTP      (ยืนยันว่าส่งเอกสาร/ผลอนุมัติกลับไปถึงจริง)
 *   2. อัปโหลดเอกสารยืนยันตัวตน     (ยืนยันว่าเป็นบุคคลนั้นจริง)
 *
 * ใช้อีเมลไม่ใช่ SMS เพราะทุกอย่างหลังจากนี้ (ผลตรวจเอกสาร การอนุมัติ บัญชีพาร์ตเนอร์)
 * ส่งเข้าอีเมลทั้งหมด ยืนยันตรงช่องทางที่จะใช้จริงจึงได้ประโยชน์กว่ายืนยันเบอร์
 *
 * ต่อ API แล้ว : POST partner/otp/request และ partner/otp/verify
 * การยืนยันสำเร็จคืน "ตั๋วใบสมัคร" (apply_token) กลับมา ซึ่งเป็นสิ่งที่ปลดล็อกขั้นตอน
 * ที่เหลือทั้งหมด (อัปเอกสาร + ส่งใบสมัคร) ตั๋วถูกส่งขึ้นไปเก็บที่หน้าแม่ผ่าน onChange
 * เพราะขั้นตอนที่ใช้ตั๋วอยู่คนละคอมโพเนนต์กับขั้นที่ได้ตั๋วมา
 *
 * ตัวนับถอยหลัง/จำนวนครั้งที่กรอกผิดในไฟล์นี้เป็นแค่สิ่งที่ผู้ใช้เห็น ด่านจริงอยู่ที่
 * server ทั้งหมด (partner.service ฝั่ง backend นับ attempt ลงตาราง partner_otps
 * และปฏิเสธเองเมื่อหมดอายุหรือขอถี่เกินไป) คนที่ยิง API ตรงจึงข้ามด่านนี้ไม่ได้
 *
 * ไฟล์เอกสารยังเก็บไว้ในหน่วยความจำของหน้าจนกว่าจะกดส่งใบสมัคร (object URL ไว้พรีวิว)
 * แล้วค่อยอัปขึ้น R2 ทีเดียวตอนกดส่ง — ผู้ที่เลือกไฟล์แล้วเปลี่ยนใจปิดแท็บไปจะได้ไม่
 * ทิ้งสำเนาบัตรประชาชนค้างอยู่ในบักเก็ตโดยไม่มีใบสมัครผูกอยู่
 * ========================================================================== */
export default class PartnerVerify extends Component {
  state = {
    sent: false,
    code: Array(OTP_LENGTH).fill(""),
    resend_in: 0,   // วินาทีที่เหลือก่อนขอรหัสใหม่ได้
    expire_in: 0,   // วินาทีที่เหลือก่อนรหัสหมดอายุ
    attempt: 0,
    otp_error: "",
    sending: false, // กันกดซ้ำระหว่างรอ API (ปุ่มขอรหัส/ยืนยันอยู่ติดกัน)
    dev_code: "",   // รหัสที่ API คืนมาให้เมื่อระบบยังส่งอีเมลจริงไม่ได้
    mail_sent: true,
    doc_error: {},  // { [slot]: "คีย์ข้อความ" } — ไฟล์ที่เลือกไม่ผ่านเงื่อนไข
  };

  inputs = [];

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  /* นาฬิกาเดียวเดินทั้งสองตัวนับ — แยกกันสองอันไม่ได้ช่วยอะไร แต่ต้องเคลียร์สองที่ */
  tick = () => {
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.setState((state) => {
        const expire_in = Math.max(0, state.expire_in - 1);
        if (!expire_in) clearInterval(this.timer);
        return { resend_in: Math.max(0, state.resend_in - 1), expire_in };
      });
    }, 1000);
  };

  /* ขอรหัสยืนยัน — เริ่มนับถอยหลัง "หลัง" จาก API ตอบสำเร็จเท่านั้น
     ถ้าเริ่มนับก่อน ผู้ใช้ที่โดนปฏิเสธ (ขอถี่เกินไป / อีเมลนี้สมัครไปแล้ว) จะเห็นตัวนับ
     เดินอยู่ทั้งที่ไม่มีรหัสถูกส่งไปไหนเลย แล้วนั่งรอเก้อ

     ค่าอายุรหัสใช้ที่ server ส่งกลับมา ไม่ใช่ค่าคงที่ฝั่งนี้ — สองฝั่งอาจไม่ตรงกันได้
     เมื่อ backend ปรับเพดาน ตัวนับบนหน้าจอต้องเดินตามของจริง */
  sendOtp = async () => {
    if (this.state.resend_in > 0 || this.state.sending) return;

    this.setState({ sending: true, otp_error: "" });
    loading(true);
    const result = await requestOtp(this.props.form.email);
    loading(false);
    this.setState({ sending: false });

    // POST เด้งข้อความจาก API ให้แล้วเมื่อไม่สำเร็จ ที่นี่จึงไม่ต้องเตือนซ้ำ
    if (result?.status !== true) return;

    this.setState({
      sent: true,
      code: Array(OTP_LENGTH).fill(""),
      resend_in: Number(result.data?.resend_in) || OTP_RESEND_SEC,
      expire_in: Number(result.data?.expires_in) || OTP_EXPIRE_SEC,
      attempt: 0,
      otp_error: "",
      /* ระบบยังไม่ได้ตั้งค่า SMTP : API คืนรหัสมาให้ทางหน้าจอแทน — "โหมดตัวอย่าง"
         เปิดทุก environment ไม่แยก dev เพราะยังไม่มีเมลเซิร์ฟเวอร์ทั้งสองฝั่ง
         และผู้ที่มาลองสมัครต้องเดินจนจบใบสมัครได้ ต่อ SMTP เมื่อไรค่านี้จะหายไปเอง */
      dev_code: result.data?.dev_code || "",
      mail_sent: result.data?.sent !== false,
    });
    this.tick();
    // โฟกัสช่องแรกให้เลย ผู้ใช้ที่สลับกลับมาจากกล่องจดหมายจะได้พิมพ์ต่อได้ทันที
    setTimeout(() => this.inputs[0]?.focus(), 0);
  };

  /* ยืนยันรหัส — ผลตัดสินมาจาก server ทั้งหมด ที่นี่ตรวจแค่ว่ากรอกครบ 6 หลักหรือยัง
     เพื่อไม่ต้องยิงคำขอที่รู้อยู่แล้วว่าไม่ผ่าน

     ตั๋ว (apply_token) ที่ได้กลับมาส่งขึ้นไปเก็บที่หน้าแม่ผ่าน onChange ไม่เก็บไว้ใน
     state ของคอมโพเนนต์นี้ เพราะขั้นอัปเอกสารและขั้นกดส่งใบสมัครอยู่คนละที่กัน
     และคอมโพเนนต์นี้ถูกถอดออกจากหน้าจอทันทีที่ผู้ใช้กด "ถัดไป" */
  verifyOtp = async () => {
    const { expire_in, sending } = this.state;
    const code = this.state.code.join("");

    if (sending) return;
    if (code.length < OTP_LENGTH) return this.setState({ otp_error: "partner_otp_incomplete" });
    if (!expire_in) return this.setState({ otp_error: "partner_otp_expired" });

    this.setState({ sending: true, otp_error: "" });
    loading(true);
    const result = await verifyOtp(this.props.form.email, code);
    loading(false);
    this.setState({ sending: false });

    if (result?.status !== true) {
      /* นับครั้งที่ผิดไว้ฝั่งนี้ด้วยเพื่อวาดข้อความให้ตรงกับที่ server กำลังนับอยู่
         (ตัวเลขจริงที่ใช้ตัดสินอยู่ในตาราง partner_otps ไม่ใช่ค่านี้)
         POST เด้งข้อความจาก API ให้แล้ว จึงไม่ตั้ง otp_error ทับเป็นข้อความของเราเอง */
      const attempt = this.state.attempt + 1;
      if (attempt >= OTP_MAX_ATTEMPT) {
        clearInterval(this.timer);
        return this.setState({
          attempt,
          expire_in: 0,
          resend_in: 0,
          code: Array(OTP_LENGTH).fill(""),
          otp_error: "partner_otp_locked",
        });
      }
      return this.setState({ attempt, code: Array(OTP_LENGTH).fill("") }, () => this.inputs[0]?.focus());
    }

    clearInterval(this.timer);
    this.setState({ otp_error: "", expire_in: 0, resend_in: 0, dev_code: "" });
    this.props.onChange({ email_verified: true, apply_token: result.data?.apply_token || "" });
  };

  /* กรอก OTP : ช่องละตัว เลื่อนโฟกัสให้เอง และวางรหัสทั้งชุดจากคลิปบอร์ดได้
     (รหัสจากอีเมลคนส่วนใหญ่ลากคลุมแล้วก๊อปมาวาง ไม่ได้พิมพ์ทีละตัว) */
  setDigit = (index, value) => {
    const digits = String(value).replace(/[^0-9]/g, "");
    if (!digits) {
      const code = [...this.state.code];
      code[index] = "";
      return this.setState({ code, otp_error: "" });
    }

    const code = [...this.state.code];
    digits.split("").forEach((digit, i) => {
      if (index + i < OTP_LENGTH) code[index + i] = digit;
    });
    this.setState({ code, otp_error: "" });

    const next = Math.min(OTP_LENGTH - 1, index + digits.length);
    this.inputs[next]?.focus();
  };

  onDigitKey = (index, event) => {
    if (event.key === "Backspace" && !this.state.code[index] && index > 0) this.inputs[index - 1]?.focus();
    if (event.key === "ArrowLeft" && index > 0) this.inputs[index - 1]?.focus();
    if (event.key === "ArrowRight" && index < OTP_LENGTH - 1) this.inputs[index + 1]?.focus();
    if (event.key === "Enter") this.verifyOtp();
  };

  /* --------------------------------------------------------------- เอกสาร */
  /* เปลี่ยนชนิดเอกสาร = ไฟล์ที่แนบไว้เป็นของอีกชนิด ใช้ต่อไม่ได้ ต้องคืนหน่วยความจำ
     ของ object URL ด้วย ไม่งั้นรูปที่ทิ้งแล้วยังกินแรมอยู่จนกว่าจะปิดแท็บ

     แนบไฟล์ไว้แล้วต้องถามก่อน — เป็นการทิ้งไฟล์เหมือนกดปุ่มลบ ต่างกันแค่ผู้ใช้
     ไม่ได้ตั้งใจจะลบ กดสลับชนิดพลาดแล้วต้องถ่ายรูปใหม่จะเสียเวลากว่ามาก */
  setDocType = async (doc_type) => {
    const docs = this.props.form.docs || {};
    if (doc_type === this.props.form.doc_type) return;

    if (Object.keys(docs).length) {
      const ok = await alert("", "warning", t("partner_doc_switch_confirm"), t("partner_doc_switch_desc"), t("confirm"), t("cancel"));
      if (!ok) return;
    }

    Object.values(docs).forEach((doc) => doc?.url && URL.revokeObjectURL(doc.url));
    this.setState({ doc_error: {} });
    this.props.onChange({ doc_type, docs: {} });
  };

  pickDoc = (slot, event) => {
    const file = event.target.files?.[0];
    // เปิดกล่องเลือกไฟล์แล้วกดยกเลิก — ของเดิมที่แนบไว้ต้องอยู่เหมือนเดิม
    event.target.value = "";
    if (!file) return;

    const error = docFileError(file);
    if (error) return this.setState((state) => ({ doc_error: { ...state.doc_error, [slot]: error } }));

    const docs = { ...(this.props.form.docs || {}) };
    if (docs[slot]?.url) URL.revokeObjectURL(docs[slot].url);
    docs[slot] = {
      name: file.name,
      size: file.size,
      type: file.type,
      // พรีวิวเฉพาะรูป — PDF โชว์เป็นไอคอนกับชื่อไฟล์แทน
      url: file.type.startsWith("image/") ? URL.createObjectURL(file) : "",
      file, // TODO(api) : ไฟล์จริงไว้ส่งขึ้นเซิร์ฟเวอร์ตอนกดส่งใบสมัคร
    };

    this.setState((state) => ({ doc_error: { ...state.doc_error, [slot]: "" } }));
    this.props.onChange({ docs });
  };

  /* ถามก่อนลบเสมอ — ไฟล์ที่แนบอยู่ในหน่วยความจำของหน้าเท่านั้น ลบแล้วกู้คืนไม่ได้
     ต้องไปหยิบไฟล์เดิมหรือถ่ายรูปใหม่ ปุ่มลบก็อยู่ติดกับพื้นที่กดเปลี่ยนไฟล์ด้วย */
  removeDoc = async (slot, label) => {
    const current = (this.props.form.docs || {})[slot];
    if (!current) return;

    const ok = await alert("", "warning", t("partner_doc_remove_confirm"), `${t(label)}\n${current.name}`, t("confirm"), t("cancel"));
    if (!ok) return;

    const docs = { ...(this.props.form.docs || {}) };
    if (docs[slot]?.url) URL.revokeObjectURL(docs[slot].url);
    delete docs[slot];
    this.setState((state) => ({ doc_error: { ...state.doc_error, [slot]: "" } }));
    this.props.onChange({ docs });
  };

  renderSlot = (slot) => {
    const doc = (this.props.form.docs || {})[slot.key];
    const error = this.state.doc_error[slot.key];
    /* กด "ถัดไป" ทั้งที่ยังไม่ครบ (errors.docs) ให้ช่องที่ยังว่างติดกรอบแดงด้วย
       ไม่งั้นเห็นแต่ข้อความรวมข้างล่าง แล้วต้องไล่หาเองว่าขาดช่องไหน */
    const missing = slot.required && !doc && !!this.props.errors?.docs;

    return (
      <div key={slot.key} className={`hm-pt-doc ${doc ? "is-filled" : ""} ${error || missing ? "is-error" : ""}`}>
        <div className="hm-pt-doc__head">
          <span className="hm-pt-doc__title">
            {t(slot.label)}
            {slot.required && <i aria-hidden="true">*</i>}
          </span>
          {!!doc && (
            <button type="button" className="hm-pt-doc__remove" onClick={() => this.removeDoc(slot.key, slot.label)}>
              <span className="hm-ico">{ICON.close}</span>
              {t("partner_doc_remove")}
            </button>
          )}
        </div>

        <label className="hm-pt-doc__drop">
          <input type="file" accept={DOC_ACCEPT} onChange={(e) => this.pickDoc(slot.key, e)} />

          {doc ? (
            <span className="hm-pt-doc__file">
              {doc.url ? (
                <img src={doc.url} alt="" className="hm-pt-doc__thumb" />
              ) : (
                <span className="hm-pt-doc__thumb hm-pt-doc__thumb--icon hm-ico">{ICON.file}</span>
              )}
              <span className="hm-pt-doc__meta">
                <b>{doc.name}</b>
                <em>{fileSize(doc.size)} · {t("partner_doc_replace")}</em>
              </span>
            </span>
          ) : (
            <span className="hm-pt-doc__empty">
              <span className="hm-ico">{ICON.image}</span>
              <b>{t("partner_doc_upload")}</b>
              <em>{t("partner_doc_hint")}</em>
            </span>
          )}
        </label>

        {!!error && <span className="hm-pt-field__error">{t(error)}</span>}
      </div>
    );
  };

  render() {
    const { form, errors = {}, onEditEmail } = this.props;
    const { sent, code, resend_in, expire_in, otp_error, sending, dev_code, mail_sent } = this.state;
    const slots = DOC_SLOTS[form.doc_type] || [];

    return (
      <>
        <div className="hm-pt-block__title">{t("partner_section_otp")}</div>

        {form.email_verified ? (
          /* ยืนยันแล้ว : ยุบเหลือแถบเดียว ไม่ต้องให้ผู้ใช้เห็นช่องกรอกรหัสอีก */
          <div className="hm-pt-verified">
            <span className="hm-pt-verified__icon hm-ico">{ICON.check_circle}</span>
            <div className="hm-pt-verified__text">
              <b>{t("partner_otp_verified")}</b>
              <span>{maskEmail(form.email)}</span>
            </div>
            <button type="button" className="hm-pt-link" onClick={onEditEmail}>
              {t("partner_otp_change")}
            </button>
          </div>
        ) : (
          <div className={`hm-pt-otp ${errors.otp ? "is-error" : ""}`}>
            <p className="hm-pt-otp__desc">
              {t("partner_otp_desc")} <b>{maskEmail(form.email)}</b>
            </p>

            {!sent ? (
              <button
                type="button"
                className="hm-btn hm-btn--primary hm-btn--sm"
                disabled={sending}
                onClick={this.sendOtp}
              >
                <span className="hm-ico">{ICON.mail}</span>
                {sending ? t("partner_otp_sending") : t("partner_otp_send")}
              </button>
            ) : (
              <>
                <div className="hm-pt-otp__boxes" role="group" aria-label={t("partner_otp_send")}>
                  {code.map((digit, index) => (
                    <input
                      key={index}
                      ref={(el) => (this.inputs[index] = el)}
                      type="text"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      maxLength={OTP_LENGTH}
                      className="hm-pt-otp__box"
                      value={digit}
                      disabled={!expire_in}
                      onChange={(e) => this.setDigit(index, e.target.value)}
                      onKeyDown={(e) => this.onDigitKey(index, e)}
                      onFocus={(e) => e.target.select()}
                    />
                  ))}
                </div>

                <p className="hm-pt-otp__hint">{t("partner_otp_spam")}</p>

                <div className="hm-pt-otp__row">
                  <span className="hm-pt-otp__timer">
                    {expire_in
                      ? `${t("partner_otp_expire")} ${countdown(expire_in)}`
                      : t("partner_otp_expired")}
                  </span>
                  <button
                    type="button"
                    className="hm-pt-link"
                    disabled={resend_in > 0 || sending}
                    onClick={this.sendOtp}
                  >
                    {resend_in > 0
                      ? t("partner_otp_resend_in").replace("{n}", resend_in)
                      : t("partner_otp_resend")}
                  </button>
                </div>

                <button
                  type="button"
                  className="hm-btn hm-btn--primary hm-btn--sm"
                  disabled={!expire_in || sending}
                  onClick={this.verifyOtp}
                >
                  <span className="hm-ico">{ICON.check}</span>
                  {t("partner_otp_verify")}
                </button>
              </>
            )}

            {/* ข้อผิดพลาดของรหัสมาก่อนเสมอ ส่วน errors.otp คือกรณีกด "ถัดไป" ทั้งที่ยังไม่ยืนยัน */}
            {(otp_error || errors.otp) && <span className="hm-pt-field__error">{t(otp_error || errors.otp)}</span>}

            {/* ระบบยังส่งอีเมลจริงไม่ได้ (SMTP ยังไม่ได้ตั้งค่า) — API คืนรหัสมาให้ทางนี้แทน
                ขึ้นทุก environment ระหว่างที่ยังไม่มีเมลเซิร์ฟเวอร์ ต่อ SMTP แล้วจะหายไปเอง */}
            {!!dev_code && (
              <span className="hm-pt-otp__demo">{t("partner_otp_demo").replace("{code}", dev_code)}</span>
            )}
            {!mail_sent && !dev_code && (
              <span className="hm-pt-otp__demo">{t("partner_otp_mail_off")}</span>
            )}
          </div>
        )}

        <div className="hm-pt-block__title">{t("partner_section_doc")}</div>
        <p className="hm-pt-note">{t("partner_doc_desc")}</p>

        <PartnerField as="div" label={t("partner_doc_type")} required full>
          <div className="hm-pt-seg">
            {DOC_TYPES.map((item) => (
              <button
                key={item.value}
                type="button"
                aria-pressed={form.doc_type === item.value}
                className={`hm-pt-seg__btn ${form.doc_type === item.value ? "is-active" : ""}`}
                onClick={() => this.setDocType(item.value)}
              >
                {t(item.label)}
              </button>
            ))}
          </div>
        </PartnerField>

        <div className="hm-pt-docs">{slots.map(this.renderSlot)}</div>

        {!!errors.docs && <span className="hm-pt-field__error">{t(errors.docs)}</span>}

        <p className="hm-pt-note hm-pt-note--muted">
          <span className="hm-ico">{ICON.shield}</span>
          {t("partner_doc_privacy")}
        </p>
      </>
    );
  }
}
